import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import LanguageTranslator from '../../../../locals/LanguageTranslator'
import { QtyAmountRow } from './BusinessDashboardCard'
import { SELL_THROUGH_SEGMENT_STYLES } from '../businessDashboardConstants'
import { dispatchHandler } from '../../../../helper/apiHelperFunctions'
import { formatNumber } from '../../../../helper/genericFunction'

// "Sales Overview" : the six sell through buckets. Each bucket is a flat tinted tile, only the
// hero bucket carries a border in the design.
const SellThroughSegments = () => {
    const dispatch = useDispatch();
    const getSalesOverviewSummaryData = useSelector(state => state?.digivendStore?.getSalesOverviewSummaryData || {});

    const [segments, setSegments] = useState([]);

    useEffect(() => {
        dispatchHandler(dispatch, "getSalesOverviewSummaryRequest", { displayName: "SALES_OVERVIEW_SUMMARY" });
    }, [dispatch]);

    useEffect(() => {
        if (getSalesOverviewSummaryData?.isSuccess) {
            const resource = getSalesOverviewSummaryData?.data?.data?.resource || getSalesOverviewSummaryData?.data?.resource || [];
            const totalQty = resource.reduce((sum, item) => sum + (Number(item?.sales_qty) || 0), 0);

            const mapped = SELL_THROUGH_SEGMENT_STYLES.map(style => {
                const item = resource.find(r => r?.performance_category === style?.category) || {};
                const qty = Number(item?.sales_qty) || 0;
                const sharePct = totalQty ? (qty / totalQty) * 100 : 0;

                return {
                    ...style,
                    subTitle: item?.logic || "",
                    value: `${sharePct.toFixed(1)}%`,
                    qty: qty.toLocaleString('en-IN'),
                    amount: `₹ ${formatNumber(item?.amount || 0).short}`,
                };
            });

            setSegments(mapped);
        }
    }, [getSalesOverviewSummaryData?.isSuccess, getSalesOverviewSummaryData?.data]);

    return (
        <div className={`bg-white border border-borderSlateGrey rounded-[10px] p-[12px] ${getSalesOverviewSummaryData?.isLoading ? 'opacity-50 pointer-events-none' : ''}`}>
            <LanguageTranslator tag='p' className='mb-[12px] text-[16px] font-semibold text-fontBlack'>Sales Overview</LanguageTranslator>

            <div className='grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-6 gap-[12px] 2xl:gap-[20px]'>
                {segments?.map(item => (
                    <div
                        key={item?.id}
                        className='rounded-[10px] p-[10px] flex flex-col gap-[10px]'
                        style={{ backgroundColor: item?.background, border: item?.border ? `1px solid ${item?.border}` : "1px solid transparent" }}
                    >
                        <div className='flex flex-col items-start justify-center'>
                            <LanguageTranslator tag='p' className='mb-0 capitalize text-[11px] font-normal leading-[1.4] text-[#111D31] whitespace-nowrap'>{item?.category}</LanguageTranslator>
                            <p className='mb-0 text-[11px] font-medium whitespace-nowrap' style={{ color: item?.subTitleColor }}>{item?.subTitle}</p>
                        </div>

                        <p className='mb-0 w-full text-[20px] font-semibold text-[#111D31]'>{item?.value}</p>

                        <QtyAmountRow qty={item?.qty} amount={item?.amount} />
                    </div>
                ))}
            </div>
        </div>
    )
}

export default SellThroughSegments
